import React from 'react';

import type { NavStep } from '../../../context/types';
import { useFormattedWalkingInstruction } from '../../../hooks/useFormattedWalkingInstruction';
import { useKioskManager } from '../../../hooks/useKioskManager';
import Icon from '../icon/Icon';
import { IconType } from '../icon/types';
import styles from './LegTwoInstruction.module.scss';

interface LegTwoInstructionProps {
  step: NavStep;
  onClick: () => void;
  isFocused: boolean;
  stepNumber: number;
  printMode?: boolean;
  nextStep?: NavStep;
}

export const LegTwoInstruction: React.FC<LegTwoInstructionProps> = ({
  step,
  nextStep,
  onClick,
  isFocused,
  stepNumber,
  printMode,
}) => {
  const formattedInstruction = useFormattedWalkingInstruction(step, nextStep);
  const { kiosk, kioskMode } = useKioskManager();

  const getIcon = (step: NavStep) => {
    switch (step.type) {
      case 'USE_ELEVATOR_UP':
      case 'USE_ELEVATOR_DOWN':
        return <Icon icon={IconType.ELEVATOR} />;
      // fill with other cases when icons are available
      case 'ESCALATOR_UP':
      case 'ESCALATOR_DOWN':
      default:
        return <div className={styles.emptyIcon} />;
    }
  };

  return (
    <div
      onClick={onClick}
      className={`
      ${styles.navStep} 
      ${isFocused && styles.isFocused} 
      ${printMode && styles.print}
      ${kiosk && kioskMode && styles[kiosk.model]}
    `}
    >
      <div className={styles.iconContainer}>
        <span
          className={`${styles.bar} ${isFocused && styles.isFocusedBar} `}
        ></span>
        {getIcon(step)}
      </div>
      <div className={styles.contentContainer}>
        <h2
          className={`${styles.instructionClass} ${
            kiosk && kioskMode && styles[kiosk.model]
          }`}
        >
          {stepNumber}.
        </h2>
        <h2
          className={`${styles.instructionClass} ${
            kiosk && kioskMode && styles[kiosk.model]
          }`}
        >
          {formattedInstruction}
        </h2>
      </div>
    </div>
  );
};
